import { errorHandler } from 'Modules'
import { call, put, takeEvery } from 'typed-redux-saga'
import { orderApi, statusesNS, statusesSlice } from 'Pages/orders_design'

export function* getOrderStatuses(action: statusesNS.getAll) {
	try {
		const { params } = action.payload
		const res = yield* call(orderApi.getStatuses, params)
		yield* put(statusesSlice.actions.setAll(res))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* statusesSaga() {
	yield* takeEvery(statusesSlice.actions.getAll, getOrderStatuses)
}
